import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AppLocalStorage } from './utils/local-storage';

@Injectable()
export class CanActivateRouteGuard implements CanActivate {
	constructor(public authService: AuthService, private router: Router) { }

	async canActivate(_next: ActivatedRouteSnapshot): Promise<boolean> {
		const authToken = AppLocalStorage.getToken();
		if (!authToken) {
			this.router.navigate(['/']);
			return false;
		}

		const isValid = await this.authService.isValidSession();
		if (!isValid) {
			this.router.navigate(['/']);
			return false;
		}

		return true;
	}
}
